import { ArrowRight, Check } from 'lucide-react';
import { FadeIn, ChapterHeading } from './Reveal';
import { PhoneMockup } from './PhoneMockup';
import { useLang } from '../i18n/LangContext';

export const PeopleSection = () => {
  const { t } = useLang();
  const PEOPLE_HIGHLIGHTS = t.people.highlights;
  return (
  <section data-testid="people-section" className="relative bg-krug-navy py-24 md:py-32 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
      <div>
        <ChapterHeading
          number="03"
          eyebrow={t.people.eyebrow}
          title={t.people.title}
          copy={t.people.copy}
        />
        <FadeIn delay={0.2}>
          <ul data-testid="people-highlights" className="mt-9 space-y-4">
            {PEOPLE_HIGHLIGHTS.map((h) => (
              <li key={h} className="flex items-center gap-3.5">
                <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-krug-teal/15 text-krug-tealbright shrink-0">
                  <Check size={14} strokeWidth={3} />
                </span>
                <span className="text-sm md:text-base text-slate-300">{h}</span>
              </li>
            ))}
          </ul>
          <a
            href="#waitlist"
            data-testid="people-cta"
            className="group mt-10 inline-flex items-center gap-2 rounded-full bg-krug-teal px-7 py-3.5 font-heading font-bold text-white hover:bg-krug-tealbright hover:text-krug-navy transition-colors duration-300"
          >
            {t.people.cta}
            <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </FadeIn>
      </div>

      <FadeIn delay={0.1} className="relative flex justify-center">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[420px] h-[420px] rounded-full bg-krug-teal/15 blur-[110px]" aria-hidden="true" />
        <div className="absolute top-8 right-6 w-28 h-28 rounded-full border border-krug-gold/25" aria-hidden="true" />
        <div className="relative w-[250px] md:w-[290px] animate-float-soft">
          <PhoneMockup src="/assets/screen-discover.webp" alt="KRUG aplikacija — pretraga ljudi i biznisa u blizini" glow="teal" />
        </div>
      </FadeIn>
    </div>
  </section>
  );
};
